export type Product = {
  title: string
  sku: string
  price: string
  imageUrl: string
  productUrl: string
}

export type CategoryData = {
  route: string
  label: string
  sourceUrl: string
  total: number
  products: Product[]
}

export const residentialCategories: CategoryData[] = [
  {
    route: '/6m8/mailboxes.html',
    label: 'Mailboxes',
    sourceUrl: 'https://www.midatlanticmailboxes.com/6m8/mailboxes.html',
    total: 534,
    products: [
      {
        title: 'Decorative Cast Aluminum Mailbox System Black',
        sku: 'BB-B Barcelona Black Curbside Mailbox System',
        price: '$369.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FBetterbox%2F2018%20pics%2FBB-Black.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/BB-B%20Barcelona%20Black%20Curbside%20Mailbox%20System--decorative-cast-aluminum-mailbox-system-black.html',
      },
      {
        title: 'WM-3 Black Wallmount Brass Eagle Mailbox',
        sku: 'WM-3',
        price: '$320.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fgaines%2F2024%20images%2FWM3.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/WM-3--wm-3-black-wallmount-brass-eagle-mailbox.html',
      },
      {
        title: 'CL-ALM-PB Classic Mailbox & Pedestal',
        sku: 'CL-ALM-PB',
        price: '$880.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fgaines%2Fgaines%2Fgaines%2FGaines%202013%20images%2FGaines%20Wallmount%20mailboxes%20eagle%20design%2Fresized%2FCL-ALM_PB.jpg400x400.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/CL-ALM-PB--cl-alm-pb-classic-mailbox-pedestal.html',
      },
      {
        title: 'Whitehall Products Dual Mailbox Package',
        sku: '16516',
        price: '$968.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fwhitehall%2FWH%20Multi%20Mount%2F16517_ANG.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/16516--whitehall-products-dual-mailbox-package.html',
      },
      {
        title: 'Whitehall Wall Mount Mailbox Black With Address Plaque 16103',
        sku: '16103',
        price: '$258.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fwhitehall%2Fwhitehall%2F10_Mailboxes%2F16103_KO.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/16103--whitehall-wall-mount-mailbox-black-with-address-plaque-16103.html',
      },
      {
        title: 'Whitehall Wall Mount Mailbox White With Address Plaque 16105',
        sku: '16105',
        price: '$258.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fwhitehall%2Fwhitehall%2F10_Mailboxes%2F16105_KO.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/16105--whitehall-wall-mount-mailbox-white-with-address-plaque-16105.html',
      },
      {
        title: 'Whitehall Wall Mount Mailbox Bronze With Address Plaque 16104',
        sku: '16104',
        price: '$258.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fwhitehall%2Fwhitehall%2F10_Mailboxes%2F16104_KO.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/16104--whitehall-wall-mount-mailbox-bronze-with-address-plaque-16104.html',
      },
      {
        title: 'QualArc Manchester Plain Mailbox Door MAN-1400',
        sku: 'MAN-1400',
        price: '$420.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fquarlarc%2Fquarlarc%2FMAN-1400%20Manchester%20Black.png',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/MAN-1400--qualarc-manchester-plain-mailbox-door-man-1400.html',
      },
      {
        title: 'QualArc Manchester Scroll Door Mailbox MAN-1401',
        sku: 'MAN-1401',
        price: '$420.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fquarlarc%2Fquarlarc%2Fman-1401%20manchester%20scroll%20antique%20copper.png',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/MAN-1401--qualarc-manchester-scroll-door-mailbox-man-1401.html',
      },
      {
        title: 'QualArc Manchester Fleur de Lis Mailbox Door MAN-1402',
        sku: 'MAN-1402',
        price: '$420.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fquarlarc%2Fquarlarc%2FMAN-1402-BZ-Manchester-with-Decorative-Fleur-De-Lis-Door-in-Bronze%20(2).jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/MAN-1402--qualarc-manchester-fleur-de-lis-mailbox-door-man-1402.html',
      },
    ],
  },
  {
    route: '/6m8/mailboxes/complete-mailbox-post-system.html',
    label: 'Complete Mailbox & Post Systems',
    sourceUrl:
      'https://www.midatlanticmailboxes.com/6m8/mailboxes/complete-mailbox-post-system.html',
    total: 235,
    products: [
      {
        title: 'Decorative Cast Aluminum Mailbox System Black',
        sku: 'BB-B Barcelona Black Curbside Mailbox System',
        price: '$369.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FBetterbox%2F2018%20pics%2FBB-Black.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/BB-B%20Barcelona%20Black%20Curbside%20Mailbox%20System--decorative-cast-aluminum-mailbox-system-black.html',
      },
      {
        title: 'CL-ALM-PB Classic Mailbox & Pedestal',
        sku: 'CL-ALM-PB',
        price: '$880.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fgaines%2Fgaines%2Fgaines%2FGaines%202013%20images%2FGaines%20Wallmount%20mailboxes%20eagle%20design%2Fresized%2FCL-ALM_PB.jpg400x400.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/CL-ALM-PB--cl-alm-pb-classic-mailbox-pedestal.html',
      },
      {
        title: 'Whitehall Products Dual Mailbox Package',
        sku: '16516',
        price: '$968.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fwhitehall%2FWH%20Multi%20Mount%2F16517_ANG.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/16516--whitehall-products-dual-mailbox-package.html',
      },
      {
        title:
          'Premier Series Curbside Mailbox with Large Scroll & Charleston base.',
        sku: 'BAMLSVIC3',
        price: '$360.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FMIDATBOX%2FMarch2023upload%2FBAM-VIC-LS-Ball.jpg1000x1000.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/BAMLSVIC3--premier-series-curbside-mailbox-with-large-scroll-charleston-base.html',
      },
      {
        title: 'Keystone Series Black Standard Post Mailbox Package',
        sku: 'KSP-BLK/KS7S/PLAQUE/KUFF',
        price: '$853.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fgaines%2F2024%20images%2FKSP%20_0037_KS7S.jpg.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/KSP-BLK/KS7S/PLAQUE/KUFF--keystone-series-black-standard-post-mailbox-package.html',
      },
      {
        title:
          'Premier BAM Curbside Mailbox w/Pedestal Scroll & Charleston base.',
        sku: 'BAMPEDVIC3',
        price: '$371.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FMIDATBOX%2FMarch2023upload%2FPremier%20Victorian%20Charlestobn%20Pedestal%20Scroll%20Mailbox%20System.jpg1000x1000.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/BAMPEDVIC3--premier-bam-curbside-mailbox-w-pedestal-scroll-charleston-base.html',
      },
      {
        title: 'Premier BAM Dual Pedestal Scroll Mailbox & Charleston base.',
        sku: 'BAMPEDDVIC3',
        price: '$398.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fpremier%2Fpremier%2Fdualpedestalcharleston.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/BAMPEDDVIC3--premier-bam-dual-pedestal-scroll-mailbox-charleston-base.html',
      },
      {
        title:
          'Premier BAM Dual Curbside Mailbox with Pedestal Scroll and Avenel base.',
        sku: 'BAMPEDDCONT3',
        price: '$398.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FMIDATBOX%2FMarch2023upload%2F20170322_143644.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/BAMPEDDCONT3--premier-bam-dual-curbside-mailbox-with-pedestal-scroll-and-avenel-base.html',
      },
      {
        title: 'Whitehall Products Ultimate Mailbox Package Bronze',
        sku: '16303',
        price: '$771.75',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FNew%20Design%202021%2FWhitehall%202021%2F16303_ultimate%20package%20bronze.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/16303--whitehall-products-ultimate-mailbox-package-bronze.html',
      },
      {
        title: 'Whitehall Products Superior Mailbox Package French Bronze',
        sku: '16306',
        price: '$581.70',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FNew%20Design%202021%2FWhitehall%202021%2Fwhitehall%20bronze%2016306_KO.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/16306--whitehall-products-superior-mailbox-package-french-bronze.html',
      },
    ],
  },
  {
    route: '/6m8/mailboxes/locking-mailboxes.html',
    label: 'Locking Mailboxes',
    sourceUrl:
      'https://www.midatlanticmailboxes.com/6m8/mailboxes/locking-mailboxes.html',
    total: 33,
    products: [
      {
        title: 'Mail Boss 7106 Curbside Locking Mailbox - BLK',
        sku: '7106',
        price: '$189.99',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FMailboss%2FMAILBOSS-BLACK.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/7106--mail-boss-7106-curbside-locking-mailbox-blk.html',
      },
      {
        title: 'Mail Boss 7108 Curbside Locking Mailbox - Bronze',
        sku: '7108',
        price: '$189.99',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FMailboss%2FMAILBOSS-BRONZE.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/7108--mail-boss-7108-curbside-locking-mailbox-bronze.html',
      },
      {
        title: 'Mail Boss 7105 Curbside Locking Mailbox - Granite',
        sku: '7105',
        price: '$189.99',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FMailboss%2FMAILBOSS-GRANITE.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/7105--mail-boss-7105-curbside-locking-mailbox-granite.html',
      },
      {
        title: 'Mail Boss 7109 Curbside Locking Mailbox - Alpine White',
        sku: '7109',
        price: '$189.99',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FMailboss%2FMAILBOSS-WHITE.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/7109--mail-boss-7109-curbside-locking-mailbox-alpine-white.html',
      },
      {
        title: 'Mail Boss 7172 Townhouse Wall Mount Locking Mailbox Black',
        sku: '7172',
        price: '$120.99',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FMailboss%2FTownhouse-BLACK.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/7172--mail-boss-7172-townhouse-wall-mount-locking-mailbox-black.html',
      },
      {
        title: 'Mail Boss 7174 Townhouse Wall Mount Locking Mailbox Bronze',
        sku: '7174',
        price: '$120.99',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FMailboss%2FTownhouse-BRONZE.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/7174--mail-boss-7174-townhouse-wall-mount-locking-mailbox-bronze.html',
      },
      {
        title: 'Mail Boss 7171 Townhouse Wall Mount Locking Mailbox Granite',
        sku: '7171',
        price: '$120.99',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FMailboss%2Fwall%2520mount_townhouse_granite_lrg.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/7171--mail-boss-7171-townhouse-wall-mount-locking-mailbox-granite.html',
      },
      {
        title:
          'Mail Boss 7179 Townhouse Wall Mount Locking Mailbox Alpine White',
        sku: '7179',
        price: '$120.99',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FMailboss%2FTownhouse-WHITE.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/7179--mail-boss-7179-townhouse-wall-mount-locking-mailbox-alpine-white.html',
      },
      {
        title: 'Mail Boss 7162 Metro Wall Mount Locking Mailbox Black',
        sku: '7162',
        price: '$110.99',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FMailboss%2Fwall%2520mount_metro_black_lrg.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/7162--mail-boss-7162-metro-wall-mount-locking-mailbox-black.html',
      },
      {
        title: 'Mail Boss 7164 Metro Wall Mount Locking Mailbox Bronze',
        sku: '7164',
        price: '$110.99',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FMailboss%2Fwall%2520mount_metro_bronze_lrg.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/7164--mail-boss-7164-metro-wall-mount-locking-mailbox-bronze.html',
      },
    ],
  },
  {
    route: '/6m8/mailboxes/wall-mount-mailboxes.html',
    label: 'Wall Mount Mailboxes',
    sourceUrl:
      'https://www.midatlanticmailboxes.com/6m8/mailboxes/wall-mount-mailboxes.html',
    total: 146,
    products: [
      {
        title: 'WM-3 Black Wallmount Brass Eagle Mailbox',
        sku: 'WM-3',
        price: '$320.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fgaines%2F2024%20images%2FWM3.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/WM-3--wm-3-black-wallmount-brass-eagle-mailbox.html',
      },
      {
        title: 'Whitehall Wall Mount Mailbox Black With Address Plaque 16103',
        sku: '16103',
        price: '$258.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fwhitehall%2Fwhitehall%2F10_Mailboxes%2F16103_KO.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/16103--whitehall-wall-mount-mailbox-black-with-address-plaque-16103.html',
      },
      {
        title: 'Whitehall Wall Mount Mailbox White With Address Plaque 16105',
        sku: '16105',
        price: '$258.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fwhitehall%2Fwhitehall%2F10_Mailboxes%2F16105_KO.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/16105--whitehall-wall-mount-mailbox-white-with-address-plaque-16105.html',
      },
      {
        title: 'Whitehall Wall Mount Mailbox Bronze With Address Plaque 16104',
        sku: '16104',
        price: '$258.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fwhitehall%2Fwhitehall%2F10_Mailboxes%2F16104_KO.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/16104--whitehall-wall-mount-mailbox-bronze-with-address-plaque-16104.html',
      },
      {
        title:
          'Special Lite Hummingbird Horizontal Wall Mount Mailbox SHB-1004-Nat',
        sku: 'SHB-1004-NAT',
        price: '$305.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FSpeciallite%2Fspeciallite%2Fshb1004_nat.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/SHB-1004-NAT--special-lite-hummingbird-horizontal-wall-mount-mailbox-shb-1004-nat.html',
      },
      {
        title:
          'Special Lite Contemporary Horizontal Wall Mount Mailbox SHC-1002',
        sku: 'SHC-1002',
        price: '$137.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FSpeciallite%2Fspeciallite%2FSHC1002.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/SHC-1002--special-lite-contemporary-horizontal-wall-mount-mailbox-shc-1002.html',
      },
      {
        title: 'Whitehall Wall Mount Mailbox No Address Plaque',
        sku: '16139',
        price: '$205.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fwhitehall%2Fwhitehall%2F10_Mailboxes%2F16139_KO.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/16139--whitehall-wall-mount-mailbox-no-address-plaque.html',
      },
      {
        title: 'WM-2 Bronze Wallmount Brass Eagle Mailbox',
        sku: 'WM-2',
        price: '$320.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fgaines%2F2024%20images%2FWM2.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/WM-2--wm-2-bronze-wallmount-brass-eagle-mailbox.html',
      },
      {
        title: 'WM-1 White/Brass Wall Mounted Eagle Mailbox',
        sku: 'WM-1',
        price: '$320.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fgaines%2F2024%20images%2FWM1.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/WM-1--wm-1-white-brass-wall-mounted-eagle-mailbox.html',
      },
      {
        title: 'WM-11 Wall Mount Solid White Mailbox',
        sku: 'WM-11',
        price: '$320.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fgaines%2F2024%20images%2FWM11.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/WM-11--wm-11-wall-mount-solid-white-mailbox.html',
      },
    ],
  },
  {
    route: '/6m8/mailbox-posts.html',
    label: 'Mailbox Posts',
    sourceUrl: 'https://www.midatlanticmailboxes.com/6m8/mailbox-posts.html',
    total: 70,
    products: [
      {
        title: 'Special Lite Fresno Direct Burial Post SPK-592',
        sku: 'SPK-592',
        price: '$426.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FSpeciallite%2FSL%20Posts%2FSPK-592-BLK.JPG',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/SPK-592--special-lite-fresno-direct-burial-post-spk-592.html',
      },
      {
        title: 'Special Lite Tacoma Mailbox Post SPK-591-DB',
        sku: 'SPK-591-DB',
        price: '$280.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FSpeciallite%2FSL%20Posts%2FSPK-591-BLK.JPG',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/SPK-591-DB--special-lite-tacoma-mailbox-post-spk-591-db.html',
      },
      {
        title: 'Special Lite Products Dual Ashland Post SPK-600-DBL',
        sku: 'SPK-600-DBL',
        price: '$479.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FSpeciallite%2Fspeciallite%2FTraditional%202020%2F600%2FSPK-600-DBL-BLK2.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/SPK-600-DBL--special-lite-products-dual-ashland-post-spk-600-dbl.html',
      },
      {
        title: 'Special Lite Bradford Direct Burial Post SPK-590',
        sku: 'SPK-590',
        price: '$295.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FSpeciallite%2FSL%20Posts%2FNew%202025%20SPK%20590%20Model%20Bradford%20Direct%20.png',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/SPK-590--special-lite-bradford-direct-burial-post-spk-590.html',
      },
      {
        title: 'Mayne Rockport Dual Vinyl Mailbox Post White - 5811-W',
        sku: '5811W',
        price: '$289.99',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FMaynePosts%2FMayne%20mailbox%20post%20new%2F5811WH-Rockport%20Dble%20White-Product-673995857739.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/5811W--mayne-rockport-dual-vinyl-mailbox-post-white-5811-w.html',
      },
      {
        title: 'Special Lite Dual Fresno Direct Burial Post SPK-592-DBL',
        sku: 'SPK-592-DBL',
        price: '$469.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FSpeciallite%2FSL%20Posts%2FSPK-592-DBL-BLK.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/SPK-592-DBL--special-lite-dual-fresno-direct-burial-post-spk-592-dbl.html',
      },
      {
        title: 'Special Lite Bradford Dual Direct Burial Post SPK-590-DBL',
        sku: 'SPK-590-DBL',
        price: '$371.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FSpeciallite%2Fspeciallite%2Fadamstowndualmailbox.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/SPK-590-DBL--special-lite-bradford-dual-direct-burial-post-spk-590-dbl.html',
      },
      {
        title: 'Special Lite Products Ashland Post SPK-600',
        sku: 'SPK-600',
        price: '$300.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FSpeciallite%2FSL%20Posts%2FSPK-600-BLK.JPG',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/SPK-600--special-lite-products-ashland-post-spk-600.html',
      },
      {
        title: 'Tacoma Surface Mount Mailbox Post w/DBL Mount Plate',
        sku: 'SPK-591-DB-DBL',
        price: '$369.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FSpeciallite%2FSL%20Posts%2FSPK-591-DBL.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/SPK-591-DB-DBL--tacoma-surface-mount-mailbox-post-w-dbl-mount-plate.html',
      },
      {
        title: 'Mayne Newport Plus Vinyl Mailbox Post White -5813W',
        sku: '5813W',
        price: '$176.99',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FMaynePosts%2FMayne%20mailbox%20post%20new%2F5813WH-NewportPlus%20White-Product-673995857838.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/5813W--mayne-newport-plus-vinyl-mailbox-post-white-5813w.html',
      },
    ],
  },
  {
    route: '/6m8/mailboxes/mailbox-replacement-parts-and-accessories.html',
    label: 'Mailbox Replacement Parts',
    sourceUrl:
      'https://www.midatlanticmailboxes.com/6m8/mailboxes/mailbox-replacement-parts-and-accessories.html',
    total: 58,
    products: [
      {
        title: 'Mayne White Solar Cap LZM625W -White',
        sku: 'LZM625W',
        price: '$84.99',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FMaynePosts%2FLZM-625-WH-Solar%20Cap%20White-Product-673995300228.jpg900x900.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/LZM625W--mayne-white-solar-cap-lzm625w-white.html',
      },
      {
        title: 'Mayne White Solar Cap LZM625B-Black',
        sku: 'LZM625B',
        price: '$84.99',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FMaynePosts%2FLZM-625-BK-Solar%20Cap%20Black-Product-673995300242.jpg900x900.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/LZM625B--mayne-white-solar-cap-lzm625b-black.html',
      },
      {
        title: 'KS-Lock Secure Lockable Insert for Keystone curbside Mailboxes',
        sku: 'KS-LOCK',
        price: '$99.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fgaines%2FKS-lock.jpg900x900.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/KS-LOCK--ks-lock-secure-lockable-insert-for-keystone-curbside-mailboxes.html',
      },
      {
        title: 'Address Sign Arm- Black',
        sku: 'MP5818BK',
        price: '$70.79',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FUpdateTemplate%2FMP5818BKaddress-arm-BK%20Black.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/MP5818BK--address-sign-arm-black.html',
      },
      {
        title: 'Address Sign Arm - White',
        sku: 'MP5818W',
        price: '$70.79',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FMayne%20Address%20signs%20new%2FMP5818WH.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/MP5818W--address-sign-arm-white.html',
      },
      {
        title: 'No Dig Ground Anchor',
        sku: '580D',
        price: '$49.99',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FMaynePosts%2F580D%20-%20No%20Dig%20Ground%20Screw%20(1).jpg800x800.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/580D--no-dig-ground-anchor.html',
      },
      {
        title: 'TSB2 Ball Topper for a 3" O/D Pole',
        sku: 'TSB2',
        price: '$39.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Ftsb2-ball%20topper.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/TSB2--tsb2-ball-topper-for-a-3-o-d-pole.html',
      },
      {
        title: 'Pineapple Topper for a 3" O/D Pole',
        sku: 'TSB5',
        price: '$47.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Ftsb5-pineapple%20topper.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/TSB5--pineapple-topper-for-a-3-o-d-pole.html',
      },
      {
        title: 'Spiral Topper for a 3" O/D Pole',
        sku: 'TSB7',
        price: '$53.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Ftsb7-spiral%20topper.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/TSB7--spiral-topper-for-a-3-o-d-pole.html',
      },
      {
        title: 'Horse Head Topper for a 3" O/D Pole',
        sku: 'TSB10',
        price: '$79.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Ftsb10-horse%20head%20topper.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/TSB10--horse-head-topper-for-a-3-o-d-pole.html',
      },
    ],
  },
  {
    route: '/6m8/curbside-mailboxes.html',
    label: 'Curbside Mailboxes',
    sourceUrl:
      'https://www.midatlanticmailboxes.com/6m8/curbside-mailboxes.html',
    total: 261,
    products: [
      {
        title: 'Special Lite Classic Curbside Mailbox With Newsbin SCC-2008',
        sku: 'SCC-2008',
        price: '$280.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2FSpeciallite%2Fspeciallite%2FClassic%202020%2FSCC-2008_BLK.jpeg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/SCC-2008--special-lite-classic-curbside-mailbox-with-newsbin-scc-2008.html',
      },
      {
        title: 'KS-23S Keystone Signature Mailbox WHT w/Satin Nickel Script',
        sku: 'KS-23S',
        price: '$405.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fgaines%2F2024%20images%2FKS-23S%20Gaines_1118.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/KS-23S--ks-23s-keystone-signature-mailbox-wht-w-satin-nickel-script.html',
      },
      {
        title: 'KS-1S Keystone Signature Mailbox WHT w/Polished Brass Script',
        sku: 'KS-1S',
        price: '$405.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fgaines%2F2024%20images%2FKS-1S%20Gaines_1086.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/KS-1S--ks-1s-keystone-signature-mailbox-wht-w-polished-brass-script.html',
      },
      {
        title: 'KS-22S Keystone Signature Mailbox WHT w/Antique Bronze Script',
        sku: 'KS-22S',
        price: '$405.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fgaines%2F2024%20images%2FKS-22S%20Gaines_1102.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/KS-22S--ks-22s-keystone-signature-mailbox-wht-w-antique-bronze-script.html',
      },
      {
        title: 'KS-21S Keystone Signature Mailbox BLK w/Antique Bronze Script',
        sku: 'KS-21S',
        price: '$405.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fgaines%2F2024%20images%2FKS-21S%20Gaines_999_7.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/KS-21S--ks-21s-keystone-signature-mailbox-blk-w-antique-bronze-script.html',
      },
      {
        title: 'KS-4S Keystone Signature Mailbox BRZ w/Polished Brass Script',
        sku: 'KS-4S',
        price: '$461.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fgaines%2F2024%20images%2FKS-4S%20Gaines_1029.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/KS-4S--ks-4s-keystone-signature-mailbox-brz-w-polished-brass-script.html',
      },
      {
        title: 'KS-25S Keystone Signature Mailbox BLK w/Satin Nickel Script',
        sku: 'KS-25S',
        price: '$405.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fgaines%2F2024%20images%2FKS-25S%20Gaines_999_23.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/KS-25S--ks-25s-keystone-signature-mailbox-blk-w-satin-nickel-script.html',
      },
      {
        title: 'KS-20S Keystone Signature Mailbox BRZ w/Antique Bronze Script',
        sku: 'KS-20S',
        price: '$405.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fgaines%2F2024%20images%2FKS-20S%20Gaines_1048.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/KS-20S--ks-20s-keystone-signature-mailbox-brz-w-antique-bronze-script.html',
      },
      {
        title: 'KS-24S Keystone Signature Mailbox BRZ w/Satin Nickel Script',
        sku: 'KS-24S',
        price: '$405.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fgaines%2F2024%20images%2FKS-24S%20Gaines_1068.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/KS-24S--ks-24s-keystone-signature-mailbox-brz-w-satin-nickel-script.html',
      },
      {
        title: 'KS-26S Keystone Signature Mailbox ALM w/Antique Bronze Script',
        sku: 'KS-26S',
        price: '$405.00',
        imageUrl:
          'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=250&h=250&file=uploaded%2Fimages%2Fgaines%2F2024%20images%2FKS-26S%20Gaines_1165.jpg',
        productUrl:
          'https://www.midatlanticmailboxes.com/m8/KS-26S--ks-26s-keystone-signature-mailbox-alm-w-antique-bronze-script.html',
      },
    ],
  },
]
